export const checkFilter = (filters) => {
    let newFilter = {};
    for (const key in filters) {
        if (filters[key] !== '') {
            newFilter[key] = filters[key];
        }
    }
    return newFilter;
}